import T from 'types'
import md5 from 'md5'
import { get, isUndefined } from 'lodash'
import SurveyTracker from '../interface'
import AbstractTracker from '../AbstractTracker'
import { storePatientAttributes, specialtyToFamily } from 'utils/trackers/utils'

const affilaeTrackingLive = {
  consultation: {
    lead: {
      sexual: "62ac7ae5cca1494eb813c775-62ac7a675cdd364eeec8dc6e",
    },
    booking: {
      sexual: "62ac7af6cca1494eb813c77f-62ac7a675cdd364eeec8dc6e",
    }
  },
}

const affilaeTrackingTest = {
  consultation: {
    lead: {
      sexual: "62ac7ae5cca1494eb813c775-62ac7a675cdd364eeec8dc6e",
    },
    booking: {
      sexual: "62ac7af6cca1494eb813c77f-62ac7a675cdd364eeec8dc6e",
    }
  },
}


const affilaeTracking = process.env.REACT_APP_LIVE_PROD_ENVIRONMENT === "true" ? affilaeTrackingLive : affilaeTrackingTest

class AffilaeTracker extends AbstractTracker implements SurveyTracker {

  config: string | undefined

  constructor() {
    super()
    this.config = process.env.REACT_APP_AFFILAE_PROGRAM_ID
  }

  private enabled(): boolean {
    return (!!this.config) && (typeof window.AeTracker !== 'undefined')
  }

  public trackLead(specialty: string) {
    const family = specialtyToFamily(specialty)
    const patientAttributes: any = storePatientAttributes()
    const aeEvent: any = new Object()
    const affilaeKey = get(affilaeTracking.consultation.lead, family)

    aeEvent.key = affilaeKey
    aeEvent.Conversion = {}
    aeEvent.Conversion.id = md5(patientAttributes.email)
    this.track(aeEvent, affilaeKey)
  }

  public trackDidPayConsultation(
    transactionId: number | any,
    transactionPrice: string,
    consultationType: string,
    medium: string,
    specialty: string,
  ) {
    const family = specialtyToFamily(specialty)
    const aeEvent: any = new Object()
    const affilaeKey = get(affilaeTracking.consultation.booking, family)

    aeEvent.key = affilaeKey
    aeEvent.Conversion = {}
    aeEvent.Conversion.id = transactionId
    aeEvent.Conversion.amount = transactionPrice
    aeEvent.Conversion.payment = 'online'
    aeEvent.Conversion.currency = 'EUR'
    this.track(aeEvent, affilaeKey)
  }

  private track = (aeEvent: any, aeKey: string): void => {
    (this.enabled() && !isUndefined(aeKey))
      ? window.AeTracker.sendConversion(aeEvent)
      : (window.AE = window.AE || []).push(aeEvent);

  }

}

export default AffilaeTracker
